import 'whatwg-fetch';
const env = process.env;

const getStrains = () => {
    	return fetch(`${env.VUE_APP_trimaster}/api/v1/strains`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
		}
	});
}

export default {
  getStrains
}